module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/bodymake-3ba9a1dc1e71395913cb9bf366ea7a95.jpg";